// extracted by mini-css-extract-plugin
export var acceptButton = "_18-6";
export var backdropBlur = "_18-0";
export var fullContent = "_18-5";
export var link = "_18-7";
export var linkIcon = "_18-8";
export var sideContent = "_18-4";
export var sideImage = "_18-3";
export var sideImageWrapper = "_18-2";
export var splitLayout = "_18-1";